import styled from 'styled-components';
import { colors } from '@/styles';

export const SchemaScrollWrapper = styled.div`
  overflow-y: scroll;
  padding: 20px;
  height: 100%;
`;

export const Messages = styled.div`
  p {
    margin-block-end: 0;
    margin-block-start: 0;
  }
`;
